import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { downgradedAngularModule } from 'src/ajs-app/app';
import { MassMessagingDetailsComponent } from './mass-messaging-details/mass-messaging-details.component';
import { MassMessagingComponent } from './mass-messaging.component';
import { MassMessagingService } from './mass-messaging.service';

downgradedAngularModule
    .directive('angularMassMessaging', downgradeComponent({ component: MassMessagingComponent }))
    .directive('angularMassMessagingDetails', downgradeComponent({ component: MassMessagingDetailsComponent }))
    .factory('AngularMassMessagingService', downgradeInjectable(MassMessagingService))
    ;
